export class OrganisationLanguageModel {
    public organisationLanguageId: string
    public organisationId: string;
    public languageCode: string;
    public primaryFlag: boolean;
    public sortSequence: number;
    public languageName: string;
}